import { render } from "./DiscoverPage.vue?vue&type=template&id=ec428950&scoped=true"
import script from "./DiscoverPage.vue?vue&type=script&lang=js"
export * from "./DiscoverPage.vue?vue&type=script&lang=js"

import "./DiscoverPage.vue?vue&type=style&index=0&id=ec428950&scoped=true&lang=css"

import exportComponent from "D:\\0my-projects\\myweb2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec428950"]])

export default __exports__